var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrahmnautIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,3.2a6.4,6.4,0,1,0,6.4,6.4A6.4,6.4,0,0,0,16,3.2Zm0,9.6a3.2,3.2,0,0,1-3.2-3.2,1,1,0,0,1,1.1-1.1h4.2a1,1,0,0,1,1.1,1.1A3.2,3.2,0,0,1,16,12.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,15.8l-1.4-1.5A7.9,7.9,0,0,0,24,12.6a8.6,8.6,0,0,1-16,0,6.2,6.2,0,0,0-2.5,1.7L4.1,15.8a3,3,0,0,0-1,2.3,3.3,3.3,0,0,0,1,2.4,3.2,3.2,0,0,0,4.6,0l.9-.9V30.9A1,1,0,0,0,10.7,32h4.2V24.5a1.1,1.1,0,0,1,2.2,0V32h4.2a1,1,0,0,0,1.1-1.1V19.6l.9.9a3.2,3.2,0,0,0,4.6,0,3.3,3.3,0,0,0,1-2.4A3,3,0,0,0,27.9,15.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1,10.7h.5V9.7a8.5,8.5,0,0,1,17,0v.9h.5l.7.3V2.1A2.1,2.1,0,0,0,23.7,0H8.5A2.2,2.2,0,0,0,6.4,2.1V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrahmnautIcon);
export default __webpack_public_path__ + "static/media/brahmnaut_icon.130b8363.svg";
export { ForwardRef as ReactComponent };